<!-- <div>
  <mat-checkbox *ngFor="let fieldSection of fieldSections" [(ngModel)]="fieldSection.IsSelected">{{fieldSection.ToolName}} -> {{fieldSection.SectionHeader}}</mat-checkbox>
</div> -->

<!-- CENTER -->
<!--<div class="center">
    &lt;!&ndash; CONTENT CARD &ndash;&gt;
    <div class="content-card mat-white-bg">

      <div class="content pos-relative m-30" fxLayout="column">
        <div class="keno-grid-container">
          <particle-virtual-grid [sourceKey]="sourceKey"
                                 sortFieldKey="Order"
                                 [invalidateSubject]="invalidateSubject"
                                 (valueChanged)="onGridCellValueChange($event)">
          </particle-virtual-grid>
        </div>
      </div>
    </div>
  </div>-->

<div class="content pos-relative flex flex-col">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceKey"
                           sortFieldKey="Order"
                           [invalidateSubject]="invalidateSubject"
                           (valueChanged)="onGridCellValueChange($event)">
    </particle-virtual-grid>
  </div>
</div>
